import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import Navbar from '../../components/navbar/navbar' 
import {
  QrCode, Printer, Package, ShoppingCart, Truck, CheckCircle,
  EyeOff, Filter, Plus, Trash2, Eye, MapPin, ChevronDown,
  ChevronUp, Loader, Barcode, Download, RefreshCw, CheckSquare  // <- ADICIONAR AQUI
} from 'lucide-react';
import 'bootstrap/dist/css/bootstrap.min.css';
import apinode from '../../services/apinode';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import QRCode from 'qrcode';
import JsBarcode from 'jsbarcode';

// pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { CheckCircleFill } from 'react-bootstrap-icons'
import { CustomButton } from '../../components/CustomButton'


const WavePickingSystem = () => {
  // ==================== ESTADOS ====================
  const [gerandoOnda, setGerandoOnda] = useState(false);
  const [loadingCargas, setLoadingCargas] = useState(false);
  const [pedidosSelecionados, setPedidosSelecionados] = useState([]);
  const [pedidoExpandido, setPedidoExpandido] = useState(null);
  const [cargas, setCargas] = useState([]);
  const [filtroData, setFiltroData] = useState('Todas');
  const [filtroRua, setFiltroRua] = useState('Todas');
  const [mostrarModal, setMostrarModal] = useState(false);
  const [cargaSelecionada, setCargaSelecionada] = useState(null);
  const [mostrarModalAtribuir, setMostrarModalAtribuir] = useState(false);
  const [ondaParaAtribuir, setOndaParaAtribuir] = useState(null);
  const [separadorSelecionado, setSeparadorSelecionado] = useState('');
  const [pedidosDisponiveis, setPedidosDisponiveis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtroUmaRua, setFiltroUmaRua] = useState(false);
  const [separadores, setSeparadores] = useState([]);
  const [modalLoadingDetalhe, setModalLoadingDetalhe] = useState(false);
  const [mostrarFinalizadas, setMostrarFinalizadas] = useState(false);
  const [textoBusca, setTextoBusca] = useState('');
  const [tipoBusca, setTipoBusca] = useState('sku');





  // ==================== UTILS ====================
  const formatarData = useCallback((dataISO) => {
    if (!dataISO) return "-";
    const data = new Date(dataISO);
    return data.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }, []);

  const formatarRua = useCallback((rua) => {
    if (typeof rua === 'number') return `Rua ${rua}`;
    if (typeof rua === 'string' && !isNaN(rua)) return `Rua ${rua}`;
    return rua;
  }, []);

  const normalizarRua = useCallback((rua) => {
    if (typeof rua === 'number') return rua;
    if (typeof rua === 'string') {
      const match = rua.match(/\d+/)
      return match ? parseInt(match[0]) : rua
    }
    return rua;
  }, []);

  const verificarEnderecoCompleto = useCallback((pedido) => {
    const itensSemEndereco = pedido.itens.filter(item =>
      !item.rua || !item.endereco ||
      item.rua === '' || item.endereco === '' ||
      item.rua === null || item.endereco === null
    );
    return {
      valido: itensSemEndereco.length === 0,
      itensSemEndereco: itensSemEndereco.length
    };
  }, []);

  const verificarUmaRua = useCallback((pedido) => {
    const ruas = [...new Set(pedido.itens.map(i => normalizarRua(i.rua)))];
    return ruas.length === 1;
  }, [normalizarRua]);

  const getRuaColor = useCallback((rua) => {
    const ruaNorm = normalizarRua(rua);
    const coresMap = {
      1: {
        bg: 'bg-primary',
        text: 'text-white',
        badge: 'bg-primary',
        btn: 'primary',
      },
      2: {
        bg: 'bg-success',
        text: 'text-white',
        badge: 'bg-success',
        btn: 'success',
      },
      3: {
        bg: 'bg-warning',
        text: 'text-dark',
        badge: 'bg-warning',
        btn: 'warning',
      },
      4: {
        bg: 'bg-danger',
        text: 'text-white',
        badge: 'bg-danger',
        btn: 'danger',
      },
      5: { bg: 'bg-info', text: 'text-dark', badge: 'bg-info', btn: 'info' },
    };
    return coresMap[ruaNorm] || { bg: 'bg-secondary', text: 'text-white', badge: 'bg-secondary', btn: 'secondary' };
  }, [normalizarRua]);

  // ==================== GERAÇÃO DE CÓDIGOS ====================
  const gerarQRCode = useCallback(async (texto) => {
    try {
      return await QRCode.toDataURL(texto, {
        width: 200,
        margin: 1,
        color: {
          dark: '#000000',
          light: '#FFFFFF'
        }
      });
    } catch (err) {
      console.error('Erro ao gerar QR Code:', err);
      return null;
    }
  }, []);

  const gerarCodigoBarras = useCallback((texto) => {
    try {
      const canvas = document.createElement('canvas');
      JsBarcode(canvas, texto, {
        format: 'CODE128',
        width: 2,
        height: 100,
        displayValue: true,
        fontSize: 14,
        margin: 10
      });
      return canvas.toDataURL('image/png');
    } catch (err) {
      console.error('Erro ao gerar código de barras:', err);
      return null;
    }
  }, []);

  // ==================== IMPRESSÃO ETIQUETA 10x15cm ====================
  const imprimirEtiqueta10x15 = useCallback(async (carga) => {
    try {
      const qrCodeDataURL = await gerarQRCode(carga.uuid || carga.id);
      const codigoBarrasDataURL = gerarCodigoBarras(carga.uuid || carga.id);

      // 10x15cm = 283.46 x 425.20 pontos (72 DPI)
      const docDefinition = {
        pageSize: {
          width: 283.46,
          height: 425.20
        },
        pageMargins: [10, 10, 10, 10],

        content: [
          // Título
          {
            text: 'ONDA DE SEPARAÇÃO',
            style: 'header',
            alignment: 'center',
            margin: [0, 5, 0, 8]
          },

          // QR Code
          {
            image: qrCodeDataURL,
            width: 120,
            alignment: 'center',
            margin: [0, 5, 0, 8]
          },

          // Código da Onda
          {
            text: carga.id || carga.uuid,
            fontSize: 16,
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 8]
          },

          // Código de Barras
          codigoBarrasDataURL ? {
            image: codigoBarrasDataURL,
            width: 240,
            alignment: 'center',
            margin: [0, 5, 0, 8]
          } : {},

          // Informações em tabela compacta
          {
            table: {
              widths: ['45%', '55%'],
              body: [
                [
                  { text: 'Pedidos:', fontSize: 9, bold: true },
                  { text: (carga.pedidos?.length || carga.totalPedidos || 0).toString(), fontSize: 10, bold: true }
                ],
                [
                  { text: 'Volumes:', fontSize: 9, bold: true },
                  { text: (carga.totalItens?.toString() || '0'), fontSize: 10, bold: true }
                ],
                [
                  { text: 'Separador:', fontSize: 9, bold: true },
                  { text: carga.separador || 'Não atribuído', fontSize: 9 }
                ],
                [
                  { text: 'Status:', fontSize: 9, bold: true },
                  {
                    text: carga.status || 'Aguardando',
                    fontSize: 9,
                    color: carga.status === 'Em Separação' ? 'green' : 'orange',
                    bold: true
                  }
                ],
                [
                  { text: 'Data:', fontSize: 9, bold: true },
                  { text: formatarData(carga.dataCriacao || carga.datahora), fontSize: 8 }
                ]
              ]
            },
            layout: 'lightHorizontalLines',
            margin: [0, 0, 0, 8]
          },

          // Rota de Separação
          {
            text: 'ROTA:',
            fontSize: 9,
            bold: true,
            margin: [0, 5, 0, 3]
          },
          {
            text: (carga.rotaSeparacao || []).map(r => `R${r}`).join(' → '),
            fontSize: 10,
            bold: true,
            color: '#667eea',
            alignment: 'center',
            margin: [0, 0, 0, 10]
          },
        ],

        styles: {
          header: {
            fontSize: 12,
            bold: true,
            color: '#667eea'
          }
        }
      };

      pdfMake.createPdf(docDefinition).open();

    } catch (error) {
      console.error('Erro ao gerar etiqueta 10x15:', error);
      alert('Erro ao gerar etiqueta. Verifique o console.');
    }
  }, [gerarQRCode, gerarCodigoBarras, formatarData]);

  // ==================== IMPRESSÃO QR CODE A4 ====================
  const imprimirQRCode = useCallback(async (carga) => {
    try {
      const qrCodeDataURL = await gerarQRCode(carga.uuid || carga.id);

      const docDefinition = {
        pageSize: 'A4',
        pageMargins: [40, 40, 40, 40],

        content: [
          {
            text: 'ETIQUETA DE IDENTIFICAÇÃO - ONDA',
            style: 'header',
            alignment: 'center',
            margin: [0, 0, 0, 20]
          },

          {
            image: qrCodeDataURL,
            width: 300,
            alignment: 'center',
            margin: [0, 20, 0, 20]
          },

          {
            table: {
              widths: ['40%', '60%'],
              body: [
                [
                  { text: 'Código Onda:', bold: true, fontSize: 14, fillColor: '#667eea', color: 'white' },
                  { text: carga.id || carga.uuid, fontSize: 16, bold: true, alignment: 'center' }
                ],
                [
                  { text: 'UUID:', bold: true, fillColor: '#f0f0f0' },
                  { text: carga.uuid || '-', fontSize: 10 }
                ],
                [
                  { text: 'Data Criação:', bold: true, fillColor: '#f0f0f0' },
                  { text: formatarData(carga.dataCriacao || carga.datahora) }
                ],
                [
                  { text: 'Total Pedidos:', bold: true, fillColor: '#f0f0f0' },
                  { text: ((carga.pedidos?.length || carga.totalPedidos || 0).toString()), fontSize: 14, bold: true }
                ],
                [
                  { text: 'Volumes:', bold: true, fillColor: '#f0f0f0' },
                  { text: (carga.totalItens?.toString() || '0'), fontSize: 14, bold: true }
                ],
                [
                  { text: 'Separador:', bold: true, fillColor: '#f0f0f0' },
                  { text: carga.separador || 'Não atribuído' }
                ],
                [
                  { text: 'Status:', bold: true, fillColor: '#f0f0f0' },
                  {
                    text: carga.status || 'Aguardando',
                    color: carga.status === 'Em Separação' ? 'green' : 'orange',
                    bold: true,
                    fontSize: 12
                  }
                ]
              ]
            },
            layout: 'lightHorizontalLines',
            margin: [0, 0, 0, 20]
          },

          {
            text: 'ROTA DE SEPARAÇÃO',
            style: 'sectionHeader',
            margin: [0, 20, 0, 10]
          },
          {
            text: (carga.rotaSeparacao || []).map(r => `Rua ${r}`).join(' → '),
            fontSize: 13,
            bold: true,
            color: '#667eea',
            alignment: 'center',
            margin: [0, 0, 0, 30]
          },

          {
            text: 'INSTRUÇÕES',
            style: 'sectionHeader',
            margin: [0, 20, 0, 10]
          },
          {
            ul: [
              'Escaneie o QR Code para acessar detalhes completos da onda',
              'Siga a rota de separação indicada acima',
              'Confira todos os itens antes de finalizar',
              'Registre qualquer divergência encontrada'
            ],
            fontSize: 11,
            margin: [20, 0, 0, 0]
          }
        ],

        styles: {
          header: {
            fontSize: 18,
            bold: true,
            color: '#667eea'
          },
          sectionHeader: {
            fontSize: 14,
            bold: true,
            color: '#667eea',
            decoration: 'underline'
          }
        }
      };

      pdfMake.createPdf(docDefinition).open();

    } catch (error) {
      console.error('Erro ao gerar etiqueta QR Code:', error);
      alert('Erro ao gerar etiqueta. Verifique o console.');
    }
  }, [gerarQRCode, formatarData]);

  // ==================== IMPRESSÃO PACKING LIST ====================
  const gerarPDFOnda = useCallback(async (carga) => {
    try {
      let dadosCompletos = carga;

      if (carga.persisted && (carga.uuid || carga.id)) {
        const conta = localStorage.idconta;
        const uuid = carga.uuid || carga.id;
        const res = await apinode.get(`/pedido/ondas/${conta}/${uuid}`);

        if (res.data && res.data.success) {
          const d = res.data.data;
          dadosCompletos = {
            id: d.header.idonda,
            uuid: d.header.uuid,
            datahora: d.header.datahora,
            dataCriacao: d.header.datahora,
            usu_gerador: d.header.usu_gerador,
            idseparador: d.header.idseparador,
            separador: d.header.SEPARADOR_NOME || d.header.usu_gerador?.toString() || 'Não atribuído',
            status: d.header.STATUS || 'Aguardando',
            rotaSeparacao: d.rotaSeparacao || [],
            itensPorRua: d.itensPorRua || {},
            totalItens: d.totalItens || 0,
            totalPedidos: d.totalPedidos || 0,
            pedidos: new Array(d.totalPedidos || 0).fill(null)
          };
        } else {
          alert('Erro ao buscar detalhes da carga para gerar PDF.');
          return;
        }
      }

      const qrCodeDataURL = await gerarQRCode(dadosCompletos.uuid || dadosCompletos.id);

      // Agrupar itens por SKU
      const itensAgrupados = {};
      if (dadosCompletos.itensPorRua) {
        Object.values(dadosCompletos.itensPorRua).forEach(itensRua => {
          itensRua.forEach(item => {
            const key = item.sku;
            if (!itensAgrupados[key]) {
              itensAgrupados[key] = {
                sku: item.sku,
                descricao: item.descricao,
                quantidade: 0,
                rua: Object.keys(dadosCompletos.itensPorRua).find(r =>
                  dadosCompletos.itensPorRua[r].some(i => i.sku === item.sku)
                ),
                endereco: item.endereco,
                pedidos: new Set()
              };
            }
            itensAgrupados[key].quantidade += item.qtd;
            itensAgrupados[key].pedidos.add(item.pedidoId);
          });
        });
      }

      const itensArray = Object.values(itensAgrupados).map(item => ({
        ...item,
        pedidos: Array.from(item.pedidos)
      }));

      itensArray.sort((a, b) => {
        const ruaA = normalizarRua(a.rua);
        const ruaB = normalizarRua(b.rua);
        if (ruaA !== ruaB) return ruaA - ruaB;
        return a.endereco.localeCompare(b.endereco);
      });

      const qrCodeColumn = qrCodeDataURL ? {
        width: '40%',
        stack: [
          {
            image: qrCodeDataURL,
            width: 150,
            alignment: 'center',
            margin: [0, 10, 0, 5]
          },
          {
            text: 'Escaneie para rastrear',
            alignment: 'center',
            fontSize: 9,
            color: '#666'
          }
        ]
      } : {
        width: '40%',
        stack: [
          {
            text: 'QR Code indisponível',
            alignment: 'center',
            fontSize: 9,
            color: '#999',
            margin: [0, 50, 0, 0]
          }
        ]
      };

      const docDefinition = {
        pageSize: 'A4',
        pageMargins: [40, 60, 40, 60],

        header: {
          columns: [
            {
              text: 'PICKING LIST - SEPARAÇÃO POR ONDA',
              style: 'header',
              alignment: 'center',
              margin: [0, 20, 0, 0]
            }
          ]
        },

        footer: function (currentPage, pageCount) {
          return {
            columns: [
              {
                text: `Gerado em: ${new Date().toLocaleString('pt-BR')}`,
                alignment: 'left',
                fontSize: 8,
                margin: [40, 0]
              },
              {
                text: `Página ${currentPage} de ${pageCount}`,
                alignment: 'right',
                fontSize: 8,
                margin: [0, 0, 40, 0]
              }
            ],
            margin: [0, 10]
          };
        },

        content: [
          {
            columns: [
              {
                width: '60%',
                stack: [
                  {
                    text: 'IDENTIFICAÇÃO DA ONDA',
                    style: 'sectionHeader',
                    margin: [0, 0, 0, 10]
                  },
                  {
                    table: {
                      widths: ['30%', '70%'],
                      body: [
                        [
                          { text: 'Código Onda:', bold: true, fillColor: '#f0f0f0' },
                          { text: dadosCompletos.id || dadosCompletos.id, fontSize: 12 }
                        ],
                        [
                          { text: 'UUID:', bold: true, fillColor: '#f0f0f0' },
                          { text: dadosCompletos.uuid || '-', fontSize: 9 }
                        ],
                        [
                          { text: 'Data Criação:', bold: true, fillColor: '#f0f0f0' },
                          { text: new Date(dadosCompletos.dataCriacao || dadosCompletos.datahora).toLocaleString('pt-BR') || '-' }
                        ],
                        [
                          { text: 'Separador:', bold: true, fillColor: '#f0f0f0' },
                          { text: dadosCompletos.separador || 'Não atribuído' }
                        ],
                        [
                          { text: 'Status:', bold: true, fillColor: '#f0f0f0' },
                          { text: dadosCompletos.status || 'Aguardando', color: dadosCompletos.status === 'Em Separação' ? 'green' : 'orange' }
                        ]
                      ]
                    },
                    layout: 'lightHorizontalLines'
                  }
                ]
              },
              qrCodeColumn
            ],
            margin: [0, 0, 0, 20]
          },

          {
            text: 'RESUMO',
            style: 'sectionHeader',
            margin: [0, 10, 0, 10]
          },
          {
            columns: [
              {
                width: '25%',
                stack: [
                  { text: 'Total de Pedidos', fontSize: 9, color: '#666' },
                  { text: (dadosCompletos.pedidos?.length || dadosCompletos.totalPedidos || 0).toString(), fontSize: 18, bold: true, color: '#667eea' }
                ]
              },
              {
                width: '25%',
                stack: [
                  { text: 'Volumes', fontSize: 9, color: '#666' },
                  { text: dadosCompletos.totalItens?.toString() || '0', fontSize: 18, bold: true, color: '#667eea' }
                ]
              },
              {
                width: '25%',
                stack: [
                  { text: 'SKUs Distintos', fontSize: 9, color: '#666' },
                  { text: itensArray.length.toString(), fontSize: 18, bold: true, color: '#667eea' }
                ]
              },
              {
                width: '25%',
                stack: [
                  { text: 'Ruas na Rota', fontSize: 9, color: '#666' },
                  { text: (dadosCompletos.rotaSeparacao?.length || 0).toString(), fontSize: 18, bold: true, color: '#667eea' }
                ]
              }
            ],
            margin: [0, 0, 0, 20]
          },

          {
            text: 'ROTA DE SEPARAÇÃO',
            style: 'sectionHeader',
            margin: [0, 10, 0, 10]
          },
          {
            text: (dadosCompletos.rotaSeparacao || []).map(r => `Rua ${r}`).join(' → ') || 'Sem rota definida',
            fontSize: 11,
            bold: true,
            color: '#667eea',
            margin: [0, 0, 0, 20]
          },

          {
            text: 'PACKING LIST - ITENS PARA SEPARAÇÃO',
            style: 'sectionHeader',
            margin: [0, 10, 0, 10],
            pageBreak: 'before'
          },
          {
            table: {
              headerRows: 1,
              widths: ['10%', '15%', '35%', '10%', '10%', '20%'],
              body: [
                [
                  { text: 'RUA', style: 'tableHeader' },
                  { text: 'SKU', style: 'tableHeader' },
                  { text: 'DESCRIÇÃO', style: 'tableHeader' },
                  { text: 'QTD', style: 'tableHeader' },
                  { text: 'COLETADO', style: 'tableHeader' },
                  { text: 'ENDEREÇO', style: 'tableHeader' }
                ],
                ...itensArray.map(item => [
                  { text: formatarRua(item.rua), fontSize: 9 },
                  { text: item.sku, fontSize: 9, bold: true },
                  { text: item.descricao, fontSize: 8 },
                  { text: item.quantidade.toString(), fontSize: 10, bold: true, alignment: 'center' },
                  { text: '', fillColor: '#f9f9f9' },
                  { text: item.endereco, fontSize: 8, color: '#666' }
                ])
              ]
            },
            layout: {
              fillColor: function (rowIndex) {
                return (rowIndex === 0) ? '#667eea' : (rowIndex % 2 === 0 ? '#f9f9f9' : null);
              },
              hLineWidth: function (i, node) {
                return (i === 0 || i === 1 || i === node.table.body.length) ? 1 : 0.5;
              },
              vLineWidth: function () {
                return 0.5;
              },
              hLineColor: function () {
                return '#ddd';
              },
              vLineColor: function () {
                return '#ddd';
              }
            }
          },

          {
            text: 'DETALHAMENTO POR PEDIDO',
            style: 'sectionHeader',
            margin: [0, 10, 0, 10],
            pageBreak: 'before'
          },
          ...(function () {
            const pedidosUnicos = new Set();
            if (dadosCompletos.itensPorRua) {
              Object.values(dadosCompletos.itensPorRua).forEach(itensRua => {
                itensRua.forEach(item => {
                  pedidosUnicos.add(item.pedidoId);
                });
              });
            }

            const resultado = [];
            pedidosUnicos.forEach(pedidoId => {
              const itensDoPedido = [];
              if (dadosCompletos.itensPorRua) {
                Object.entries(dadosCompletos.itensPorRua).forEach(([rua, itensRua]) => {
                  itensRua.forEach(item => {
                    if (item.pedidoId === pedidoId) {
                      itensDoPedido.push({ ...item, rua: rua });
                    }
                  });
                });
              }

              if (itensDoPedido.length > 0) {
                resultado.push({
                  text: `Pedido: ${pedidoId}`,
                  style: 'subHeader',
                  margin: [0, 10, 0, 5]
                });

                resultado.push({
                  ul: itensDoPedido.map(i =>
                    `${i.sku} - ${i.descricao} | Qtd: ${i.qtd} | Rua ${i.rua} - ${i.endereco}`
                  ),
                  fontSize: 9,
                  margin: [0, 0, 0, 10]
                });
              }
            });

            return resultado;
          })(),

          {
            text: 'CONFERÊNCIA E ASSINATURAS',
            style: 'sectionHeader',
            margin: [0, 30, 0, 20],
            pageBreak: 'before'
          },
          {
            columns: [
              {
                width: '50%',
                stack: [
                  { text: '_'.repeat(40), alignment: 'center', margin: [0, 40, 0, 5] },
                  { text: 'Separador', alignment: 'center', fontSize: 10 },
                  { text: 'Data: ____/____/________', alignment: 'center', fontSize: 9, margin: [0, 5, 0, 0] }
                ]
              },
              {
                width: '50%',
                stack: [
                  { text: '_'.repeat(40), alignment: 'center', margin: [0, 40, 0, 5] },
                  { text: 'Conferente', alignment: 'center', fontSize: 10 },
                  { text: 'Data: ____/____/________', alignment: 'center', fontSize: 9, margin: [0, 5, 0, 0] }
                ]
              }
            ]
          },
          {
            text: 'OBSERVAÇÕES',
            style: 'sectionHeader',
            margin: [0, 30, 0, 10]
          },
          {
            table: {
              widths: ['100%'],
              body: [
                [{ text: '\n\n\n\n\n', border: [true, true, true, true] }]
              ]
            }
          }
        ],

        styles: {
          header: {
            fontSize: 16,
            bold: true,
            color: '#667eea'
          },
          sectionHeader: {
            fontSize: 13,
            bold: true,
            color: '#667eea',
            decoration: 'underline'
          },
          subHeader: {
            fontSize: 11,
            bold: true,
            color: '#333'
          },
          tableHeader: {
            bold: true,
            fontSize: 10,
            color: 'white',
            fillColor: '#667eea',
            alignment: 'center'
          }
        }
      };

      pdfMake.createPdf(docDefinition).open();

    } catch (error) {
      console.error('Erro ao gerar PDF:', error);
      alert('Erro ao gerar PDF. Verifique o console.');
    }
  }, [gerarQRCode, normalizarRua, formatarRua]);

  // ==================== API CALLS ====================
  const buscarPedidos = useCallback(async () => {
    try {
      setLoading(true)
      const response = await apinode.get(`/pedido/wave/${localStorage.idconta}`)
      setPedidosDisponiveis(response.data.data || [])
    } catch (error) {
      console.error('❌ Erro ao buscar pedidos:', error)
      setPedidosDisponiveis([])
    } finally {
      setLoading(false)
    }
  }, []);

  const SearchUsers = useCallback(async () => {
    try {
      setLoading(true)
      const response = await apinode.get(
        `/pedido/usuarios/${localStorage.idconta}`,
      )
      const usuariosLimpos = response.data.data.map((user) => ({
        ...user,
        nome: user?.nome.trim(),
        status: user.status.trim(),
      }))
      setSeparadores(usuariosLimpos)
    } catch (error) {
      console.error('❌ Erro ao buscar separadores:', error)
      setSeparadores([])
    } finally {
      setLoading(false)
    }
  }, []);

  const carregarOndas = useCallback(async () => {
    try {
      setLoadingCargas(true);
      const conta = localStorage.idconta;
      const res = await apinode.get(`/pedido/ondas/${conta}`);
      const ondasDBRaw = (res.data && res.data.data) ? res.data.data : [];

      const ondasDB = ondasDBRaw.map((o) => ({
        ...o,
        persisted: true,
        uuid: o.uuid || o.UUID || o.UUID_ONDA || null,
        id: o.id || o.ID || `ONDA-${String(Math.random()).slice(2, 8)}`,
        totalItens: o.totalitens || o.TOTALITENS || o.totalItens || 0,
        totalPedidos: o.totalpedidos || o.TOTALPEDIDOS || o.totalPedidos || 0,
        pedidos: new Array(o.totalpedidos || o.TOTALPEDIDOS || 0).fill(null),
        rotaSeparacao: o.rotaSeparacao || o.rota_separacao || [],
        separador: o.separador || o.SEPARADOR || null,
        status: o.status || o.STATUS || null,
        dtinicio: o.dtinicio || o.DTINICIO || null,
        dtfim: o.dtfim || o.DTFIM || null,
        datahora: o.datahora || o.DATAHORA || null
      }));

      const ondasTemp =
        JSON.parse(localStorage.getItem('ondasTemp') || '[]') || []

      const merged = [
        ...ondasDB,
        ...ondasTemp.filter(
          (t) => !ondasDB.some((d) => d.uuid && d.uuid === t.uuid),
        ),
      ]

      setCargas(merged)
    } catch (err) {
      console.error('Erro carregando ondas:', err)
      setCargas([])
    } finally {
      setLoadingCargas(false)
    }
  }, []);

  // ==================== EFFECTS ====================
  // useEffect(() => {
  //   const carregarDados = async () => {
  //     try {
  //       await Promise.all([
  //         buscarPedidos(),
  //         SearchUsers(),
  //         carregarOndas()
  //       ]);
  //     } catch (error) {
  //       console.error("❌ Erro ao carregar dados iniciais:", error);
  //     }
  //   };
  //   carregarDados();
  // }, [buscarPedidos, SearchUsers, carregarOndas]);
  useEffect(() => {
    const carregarDados = async () => {
      try {
        // Carrega pedidos primeiro
        await buscarPedidos();

        // Depois carrega usuários
        await SearchUsers();

        // Por último carrega ondas
        await carregarOndas();

        console.log('✅ Todos os dados carregados com sucesso!');

      } catch (error) {
        console.error('❌ Erro ao carregar dados iniciais:', error)
      }
    };
    carregarDados();
  }, [buscarPedidos, SearchUsers, carregarOndas]);

  useEffect(() => {
    const ondasTemp = cargas.filter((c) => !c.persisted)
    localStorage.setItem('ondasTemp', JSON.stringify(ondasTemp))
  }, [cargas])

  // ==================== UI HANDLERS ====================
  const toggleExpandirPedido = useCallback((pedidoId) => {
    setPedidoExpandido(prev => prev === pedidoId ? null : pedidoId);
  }, []);

  const toggleSelecionarPedido = useCallback((pedido) => {
    const validacao = verificarEnderecoCompleto(pedido);

    if (!validacao.valido) {
      alert(
        `❌ Pedido ${pedido.id} possui ${validacao.itensSemEndereco} item(ns) sem endereçamento completo (Rua ou Endereço vazios). Por favor, endereçe todos os itens antes de selecionar.`,
      )
      return
    }

    if (filtroUmaRua && !verificarUmaRua(pedido)) {
      const ruasCount = [
        ...new Set(pedido.itens.map((i) => normalizarRua(i.rua))),
      ].length

      alert(
        `❌ Pedido ${pedido.id} possui ${ruasCount} ruas diferentes. O filtro "Apenas Uma Rua" está ativo. Desative o filtro ou selecione apenas pedidos com uma única rua.`,
      )

      return
    }

    setPedidosSelecionados(prev => {
      const jaSelecionado = prev.find(p => p.id === pedido.id);
      if (jaSelecionado) {
        return prev.filter(p => p.id !== pedido.id);
      } else {
        return [...prev, pedido];
      }
    });
  }, [verificarEnderecoCompleto, verificarUmaRua, filtroUmaRua, normalizarRua]);

  const selecionarPorRua = useCallback((rua) => {
    const ruaNorm = normalizarRua(rua);
    const pedidosDaRua = pedidosDisponiveis.filter(pedido =>
      pedido.itens.some(item => normalizarRua(item.rua) === ruaNorm) &&
      (filtroData === 'Todas' || pedido.dataDespacho === filtroData)
    );

    let pedidosValidos = pedidosDaRua.filter(
      (pedido) => verificarEnderecoCompleto(pedido).valido,
    )

    if (filtroUmaRua)
      pedidosValidos = pedidosValidos.filter((pedido) =>
        verificarUmaRua(pedido),
      )

    const pedidosInvalidos = pedidosDaRua.length - pedidosValidos.length
    if (pedidosInvalidos > 0) {
      alert(
        `⚠️ ${pedidosInvalidos} pedido(s) da ${formatarRua(rua)} foram ignorados por possuírem itens sem endereçamento completo${filtroUmaRua ? ' ou múltiplas ruas' : ''}.`,
      )
    }

    setPedidosSelecionados(pedidosValidos);
  }, [normalizarRua, pedidosDisponiveis, filtroData, verificarEnderecoCompleto, filtroUmaRua, verificarUmaRua, formatarRua]);

  const selecionarTodosItensRua = useCallback((rua) => {
    const ruaNorm = normalizarRua(rua);
    const todosPedidosComRua = pedidosDisponiveis.filter(pedido =>
      pedido.itens.some(item => normalizarRua(item.rua) === ruaNorm)
    );

    let pedidosValidos = todosPedidosComRua.filter(
      (pedido) => verificarEnderecoCompleto(pedido).valido,
    )
    if (filtroUmaRua)
      pedidosValidos = pedidosValidos.filter((pedido) =>
        verificarUmaRua(pedido),
      )

    const pedidosInvalidos = todosPedidosComRua.length - pedidosValidos.length
    if (pedidosInvalidos > 0) {
      alert(
        `⚠️ ${pedidosInvalidos} pedido(s) da ${formatarRua(rua)} foram ignorados por possuírem itens sem endereçamento completo${filtroUmaRua ? ' ou múltiplas ruas' : ''}.`,
      )
    }

    setPedidosSelecionados(pedidosValidos);
  }, [normalizarRua, pedidosDisponiveis, verificarEnderecoCompleto, filtroUmaRua, verificarUmaRua, formatarRua]);

  const abrirModalAtribuir = useCallback((carga) => {
    setOndaParaAtribuir(carga);
    setSeparadorSelecionado('');
    setMostrarModalAtribuir(true);
  }, []);

  const atribuirSeparador = useCallback(() => {
    if (!separadorSelecionado) {
      alert('Selecione um separador!')
      return
    }

    const separador = separadores.find((s) => s.id === separadorSelecionado)
    const cargasAtualizadas = cargas.map((c) => {
      if (
        (c.uuid && c.uuid === ondaParaAtribuir.uuid) ||
        c.id === ondaParaAtribuir.id ||
        c.tempId === ondaParaAtribuir.tempId
      ) {
        return {
          ...c,
          status: 'Em Separação',
          separador: separador.nome,
          separadorId: separador.id,
          dataAtribuicao: new Date().toLocaleString('pt-BR'),
        }
      }
      return c
    })

    setCargas(cargasAtualizadas);
    setMostrarModalAtribuir(false);
    alert(`Onda ${ondaParaAtribuir.id} atribuída para ${separador.nome}!`);
  }, [separadorSelecionado, separadores, cargas, ondaParaAtribuir]);

  const gerarCarga = useCallback(() => {
    if (pedidosSelecionados.length === 0) {
      alert('Selecione pelo menos um pedido!')
      return
    }

    const todosItens = pedidosSelecionados.flatMap((p) =>
      p.itens.map((item) => ({ ...item, pedidoId: p.id, cliente: p.cliente })),
    )

    const itensPorRua = todosItens.reduce((acc, item) => {
      const ruaNorm = normalizarRua(item.rua)
      if (!acc[ruaNorm]) acc[ruaNorm] = []
      acc[ruaNorm].push(item)
      return acc
    }, {})

    const novaCarga = {
      tempId: `TMP-${Date.now()}`,
      persisted: false,
      id: `ONDA-${String(cargas.length + 1).padStart(3, '0')}`,
      pedidos: pedidosSelecionados,
      totalItens: pedidosSelecionados.reduce((acc, p) => acc + p.totalItens, 0),
      itensPorRua,
      dataCriacao: new Date().toLocaleString('pt-BR'),
      status: 'Aguardando Separação',
      rotaSeparacao: Object.keys(itensPorRua)
        .map((r) => parseInt(r))
        .sort((a, b) => a - b),
    }

    setCargas(prev => [...prev, novaCarga]);
    setPedidosDisponiveis(prev => prev.filter(p => !pedidosSelecionados.find(ps => ps.id === p.id)));
    setPedidosSelecionados([]);
    setPedidoExpandido(null);
  }, [pedidosSelecionados, normalizarRua, cargas.length]);

  const visualizarCarga = useCallback(async (carga) => {
    try {
      setMostrarModal(true)
      setModalLoadingDetalhe(true)

      if (carga.persisted && (carga.uuid || carga.id)) {
        const conta = localStorage.idconta
        const uuid = carga.uuid || carga.id
        const res = await apinode.get(`/pedido/ondas/${conta}/${uuid}`)
        if (res.data && res.data.success) {
          const d = res.data.data
          const cargaNormalizada = {
            id: d.header.UUID,
            datahora: d.header.DATAHORA,
            usu_gerador: d.header.USU_GERADOR,
            idseparador: d.header.IDSEPARADOR,
            rotaSeparacao: d.rotaSeparacao,
            itensPorRua: d.itensPorRua,
            totalItens: d.totalItens,
            pedidos: new Array(d.totalPedidos || 0).fill(null),
          }
          setCargaSelecionada(cargaNormalizada)
        } else {
          alert('Erro ao buscar detalhes da carga.')
        }
      } else {
        setCargaSelecionada(carga)
      }
    } catch (err) {
      console.error('Erro ao visualizar carga:', err)
      alert('Erro ao buscar detalhes da carga. Veja console.')
    } finally {
      setModalLoadingDetalhe(false)
    }
  }, []);

  const iniciarSeparacaoSalvar = useCallback(async (carga) => {
    try {
      setGerandoOnda(true)
      const conta = localStorage.idconta
      const payload = {
        usu_gerador: localStorage.idusuario || 'Sistema',
        idseparador: separadorSelecionado || null,
        itens: carga.itensPorRua ? Object.values(carga.itensPorRua).flat() : [],
      }

      const response = await apinode.post(
        `/pedido/ondas/${conta}/gerar`,
        payload,
      )

      if (response.data && response.data.success) {
        const uuid = response.data.uuid
        alert(`✅ Onda ${uuid} gerada com sucesso!`)

        setCargas((prev) =>
          prev.map((c) => {
            if (c.tempId && carga.tempId && c.tempId === carga.tempId) {
              return { ...c, persisted: true, uuid, id: uuid }
            }
            return c
          }),
        )

        await carregarOndas()
        setMostrarModal(false)
      } else {
        alert(
          `⚠️ Falha ao gerar onda: ${response.data?.message || 'sem mensagem'}`,
        )
      }
    } catch (error) {
      console.error('Erro ao gerar onda:', error)
      alert('❌ Erro ao gerar onda. Verifique o console.')
    } finally {
      setGerandoOnda(false)
    }
  }, [separadorSelecionado, carregarOndas]);

  // ==================== COMPUTED VALUES ====================
  const datasDisponiveis = useMemo(() =>
    [...new Set(pedidosDisponiveis.map(p => p.dataDespacho))].sort(),
    [pedidosDisponiveis]
  );

  const todasRuas = useMemo(() =>
    [...new Set(
      pedidosDisponiveis.flatMap(p => p.itens.map(i => normalizarRua(i.rua)))
    )].filter(rua => rua !== null && rua !== '' && rua !== undefined).sort((a, b) => a - b),
    [pedidosDisponiveis, normalizarRua]
  );

  const pedidosFiltrados = useMemo(() => {
    return pedidosDisponiveis.filter(p => {
      const matchBusca = (() => {
        if (!textoBusca.trim()) return true;
        const busca = textoBusca.toLowerCase();
        return p.itens.some(item => {
          if (tipoBusca === 'sku') {
            return item.sku.toString().toLowerCase().includes(busca);
          }
          if (tipoBusca === 'descricao') {
            return item.descricao.toLowerCase().includes(busca);
          }
          return true;
        });
      })();

      const matchData = filtroData === 'Todas' || p.dataDespacho === filtroData;
      const matchRua = filtroRua === 'Todas' || p.itens.some(item => normalizarRua(item.rua) === normalizarRua(filtroRua));
      const matchUmaRua = !filtroUmaRua || verificarUmaRua(p);

      return matchBusca && matchData && matchRua && matchUmaRua;
    });
  }, [pedidosDisponiveis, textoBusca, tipoBusca, filtroData, filtroRua, filtroUmaRua, normalizarRua, verificarUmaRua]);

  const totalItensSelecionados = useMemo(() =>
    pedidosSelecionados.reduce((acc, p) => acc + p.totalItens, 0),
    [pedidosSelecionados]
  );

  const cargasAtivas = useMemo(() =>
    cargas.filter(c => !c.dataFim),
    [cargas]
  );

  const cargasFinalizadas = useMemo(() =>
    cargas.filter(c => c.dataFim),
    [cargas]
  );

  const selecionarTodosFiltrados = useCallback(() => {
    const pedidosValidos = pedidosFiltrados.filter(pedido =>
      verificarEnderecoCompleto(pedido).valido
    );

    const pedidosInvalidos = pedidosFiltrados.length - pedidosValidos.length;

    if (pedidosInvalidos > 0) {
      alert(`⚠️ ${pedidosInvalidos} pedido(s) foram ignorados por possuírem itens sem endereçamento completo.`);
    }

    if (pedidosValidos.length === 0) {
      alert('❌ Nenhum pedido válido encontrado nos filtros atuais.');
      return;
    }

    setPedidosSelecionados(pedidosValidos);
    alert(`✅ ${pedidosValidos.length} pedido(s) selecionado(s) com sucesso!`);
  }, [pedidosFiltrados, verificarEnderecoCompleto]);

  // ==================== LOADING SCREEN ====================
  if (loading) {
    return (
      <div
        style={{
          backgroundColor: '#f8f9fa',
          minHeight: '100vh',
          padding: '20px',
        }}
        className="d-flex align-items-center justify-content-center"
      >
        <div className="text-center">
          <div className="mb-4">
            <Loader
              size={64}
              className="text-primary"
              style={{ animation: 'spin 1s linear infinite' }}
            />
          </div>
          <h4 className="text-muted mb-2">Carregando Pedidos...</h4>
          <p className="text-muted">
            Aguarde enquanto os dados são processados
          </p>
          <style>{`
            @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
          `}</style>
        </div>
      </div>
    )
  }

  // ==================== RENDER ====================
  return (
    <>
      <Navbar />
      <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', padding: '20px' }}>
        <div className="container-fluid">
          {/* Header */}
          <div className="row mb-4">
            <div className="col-12">
              <div className="card border-0 shadow-sm" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
                <div className="card-body text-white py-4">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <Package size={40} className="me-3" />
                      <div>
                        <h2 className="mb-1">Sistema de Separação por Onda - WMS</h2>
                        <p className="mb-0 opacity-75 text-white">Organize cargas por endereçamento e otimize a rota de separação</p>
                      </div>
                    </div>
                    <button
                      className="btn btn-light d-flex align-items-center gap-2"
                      onClick={() => {
                        buscarPedidos();
                        carregarOndas();
                      }}
                      disabled={loading || loadingCargas}
                    >
                      <RefreshCw size={18} />
                      Atualizar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Dashboard Cards */}
          <div className="row mb-4">
            <div className="col-md-3 mb-3">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 className="text-muted mb-1">Pedidos Ag. Conf.</h6>
                      <h3 className="mb-0">{pedidosDisponiveis.length}</h3>
                    </div>
                    <div className="bg-primary bg-opacity-10 p-3 rounded">
                      <ShoppingCart className="text-primary" size={24} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-3">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 className="text-muted mb-1">Selecionados</h6>
                      <h3 className="mb-0">{pedidosSelecionados.length}</h3>
                    </div>
                    <div className="bg-success bg-opacity-10 p-3 rounded">
                      <CheckCircle className="text-success" size={24} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-3">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 className="text-muted mb-1">Ondas Geradas</h6>
                      <h3 className="mb-0">{cargas.length}</h3>
                    </div>
                    <div className="bg-warning bg-opacity-10 p-3 rounded">
                      <Truck className="text-warning" size={24} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-3">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 className="text-muted mb-1">Volumes</h6>
                      <h3 className="mb-0">{totalItensSelecionados}</h3>
                    </div>
                    <div className="bg-info bg-opacity-10 p-3 rounded">
                      <Package className="text-info" size={24} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Main layout */}
          <div className="row g-3">
            {/* Pedidos Disponíveis */}
            <div className="col-lg-8 mb-4">
              <div className="card border-0 shadow-sm" style={{ minHeight: "100%" }}>
                <div className="card-header bg-white border-0 py-3">
                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <h5 className="mb-0"><Filter size={20} className="me-2" />Pedidos Disponíveis</h5>
                    <div className="d-flex gap-2 flex-wrap">
                      <select
                        className="form-select form-select-sm"
                        style={{ width: 'auto' }}
                        value={filtroData}
                        onChange={(e) => setFiltroData(e.target.value)}
                      >
                        <option value="Todas">Todas as Datas</option>
                        {datasDisponiveis.map((data) => (
                          <option key={data} value={data}>
                            {formatarData(data)}
                          </option>
                        ))}
                      </select>

                      <select
                        className="form-select form-select-sm"
                        style={{ width: 'auto' }}
                        value={filtroRua}
                        onChange={(e) => setFiltroRua(e.target.value)}
                      >
                        <option value="Todas">Todas as Ruas</option>
                        {todasRuas.map(rua => (
                          <option key={rua} value={rua}>{formatarRua(rua)}</option>
                        ))}
                      </select>
                      <div className="form-check" style={{ marginLeft: '10px' }}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="filtroUmaRua"
                          checked={filtroUmaRua}
                          onChange={(e) => setFiltroUmaRua(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="filtroUmaRua" style={{ marginTop: '2px' }}>
                          Apenas Uma Rua
                        </label>
                      </div>
                    </div>
                  </div>
                </div>


                <div className="mb-3 px-3">
                  <div className="d-flex gap-2 align-items-center flex-wrap">
                    {/* Botão Selecionar Todos */}
                    <button
                      className="btn btn-success d-flex align-items-center gap-2"
                      onClick={selecionarTodosFiltrados}
                      disabled={pedidosFiltrados.length === 0}
                      title={`Selecionar todos os ${pedidosFiltrados.length} pedidos filtrados`}
                    >
                      <CheckSquare size={18} />
                      Selecionar Filtrados ({pedidosFiltrados.length})
                    </button>

                    {/* Campo de Busca */}
                    <div className="input-group flex-grow-1" style={{ maxWidth: 500 }}>
                      <span className="input-group-text bg-white">
                        <Filter size={16} />
                      </span>
                      <select
                        className="form-select"
                        style={{ maxWidth: 140 }}
                        value={tipoBusca}
                        onChange={(e) => setTipoBusca(e.target.value)}
                      >
                        <option value="sku">SKU</option>
                        <option value="descricao">Descrição</option>
                      </select>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={`Digite ${tipoBusca === 'sku' ? 'o SKU' : 'a descrição'}...`}
                        value={textoBusca}
                        onChange={(e) => setTextoBusca(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="card-body p-3" style={{ minHeight: "100%", overflowY: 'auto', maxHeight: '70vh' }}>
                  {pedidosFiltrados.length === 0 ? (
                    <div className="text-center text-muted py-5">
                      <Package size={44} className="mb-2 opacity-50" />
                      <div className="small">Nenhum pedido encontrado com os filtros selecionados</div>
                    </div>
                  ) : (
                    pedidosFiltrados.map((pedido) => {
                      const selecionado = pedidosSelecionados.some(p => p.id === pedido.id);
                      const expandido = pedidoExpandido === pedido.id;
                      const validacao = verificarEnderecoCompleto(pedido);
                      const temProblema = !validacao.valido;

                      const cardClass = `mb-3 shadow-sm rounded-3 border ${selecionado ? 'border-success' : temProblema ? 'border-danger' : 'border-light'}`;
                      const cardStyle = { backgroundColor: selecionado ? '#f6ffef' : temProblema ? '#fff5f5' : 'white' };

                      const ruasDoPedido = [...new Set(pedido.itens.map(i => normalizarRua(i.rua)))];

                      return (
                        <article key={pedido.id} className={cardClass} style={cardStyle}>
                          <div className="d-flex align-items-start gap-3 p-3">
                            <div className="flex-grow-1">
                              <div className="d-flex align-items-center justify-content-between">
                                <div>
                                  <div className="d-flex align-items-center gap-2">
                                    <h6 className="mb-0 me-2" style={{ fontSize: '0.95rem' }}>{pedido.id}</h6>
                                    <small className="badge bg-transparent text-secondary border py-1">{pedido.status}</small>
                                    {temProblema && (
                                      <small className="badge bg-danger text-white ms-2 py-1" title={`${validacao.itensSemEndereco} item(ns) sem endereço`}>
                                        ⚠️ {validacao.itensSemEndereco}
                                      </small>
                                    )}
                                  </div>
                                </div>

                                <div className="d-flex align-items-center gap-2">
                                  {selecionado && <CheckCircle size={20} className="text-success" />}
                                  <button
                                    className="btn btn-sm btn-outline-success"
                                    onClick={() => !temProblema && toggleSelecionarPedido(pedido)}
                                    disabled={temProblema}
                                    title={temProblema ? 'Corrija os endereços antes de selecionar' : 'Selecionar pedido para gerar onda'}
                                  >
                                    {selecionado ? 'Selecionado' : 'Selecionar'}
                                  </button>
                                  <button
                                    className="btn btn-sm btn-outline-secondary p-0 d-flex align-items-center justify-content-center"
                                    style={{ width: 30, height: 30 }}
                                    onClick={() => toggleExpandirPedido(pedido.id)}
                                    aria-label={expandido ? 'Recolher' : 'Expandir'}
                                  >
                                    {expandido ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="border-top bg-light p-3">
                            <h6 className="mb-3 small d-flex align-items-center gap-2">
                              <Package size={14} /> Itens do Pedido
                            </h6>
                            <div className="table-responsive">
                              <table className="table table-sm mb-0" style={{ minWidth: 640 }}>
                                <thead className="table-light small">
                                  <tr>
                                    <th style={{ width: 90 }}>SKU</th>
                                    <th>Descrição</th>
                                    <th style={{ width: 60 }}>Qtd</th>
                                    <th style={{ width: 140 }}>Rua</th>
                                    <th style={{ width: 200 }}>Endereço</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {pedido.itens.map((item, idx) => {
                                    const cor = getRuaColor(item.rua);
                                    const semEndereco = !item.rua || !item.endereco || item.rua === '' || item.endereco === '' || item.rua === null || item.endereco === null;

                                    return (
                                      <tr key={idx} className={semEndereco ? 'table-danger' : ''}>
                                        <td><span className="badge bg-secondary">{item.sku}</span></td>
                                        <td className="small">{item.descricao}</td>
                                        <td><strong>{item.qtd}</strong></td>
                                        <td>
                                          {semEndereco ? (
                                            <small className="badge bg-danger">Sem Rua</small>
                                          ) : (
                                            <small className={`badge ${cor.badge} text-truncate`} title={formatarRua(item.rua)}>
                                              {formatarRua(item.rua)}
                                            </small>
                                          )}
                                        </td>
                                        <td>
                                          {!item.endereco ? (
                                            <small className="text-danger">Sem Endereço</small>
                                          ) : (
                                            <code style={{ fontSize: '0.85rem' }}>{item.endereco}</code>
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </div>

                          {expandido && (
                            <div className="border-top p-3">
                              <h6 className="mb-3 small d-flex align-items-center gap-2">
                                <Eye size={14} /> Informações do Pedido
                              </h6>

                              <div className="row g-3">
                                <div className="col-md-6">
                                  <div className="card border-0 bg-light">
                                    <div className="card-body py-2">
                                      <div className="small text-muted">Cliente</div>
                                      <div className="fw-semibold">{pedido.cliente}</div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="card border-0 bg-light">
                                    <div className="card-body py-2">
                                      <div className="small text-muted">Data Despacho</div>
                                      <div className="fw-semibold">📅 {formatarData(pedido.dataDespacho)}</div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="card border-0 bg-light">
                                    <div className="card-body py-2">
                                      <div className="small text-muted">Volumes</div>
                                      <div className="fw-semibold"><Package size={12} /> {pedido.totalItens}</div>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-12">
                                  <div className="card border-0">
                                    <div className="card-body py-2">
                                      <div className="small text-muted mb-1">Ruas do Pedido</div>
                                      {ruasDoPedido.map((rua, idx) => {
                                        const cor = getRuaColor(rua);
                                        return (
                                          <span key={idx} className={`badge ${cor.badge} me-1 mb-1`}>
                                            {formatarRua(rua)}
                                          </span>
                                        );
                                      })}
                                    </div>
                                  </div>
                                </div>

                                <div className="col-12">
                                  <div className="alert alert-secondary mb-0 small">
                                    <div><strong>Status:</strong> {pedido.status}</div>
                                    <div><strong>ID:</strong> {pedido.id}</div>
                                    {temProblema && (
                                      <div className="text-danger mt-2">
                                        ⚠️ {validacao.itensSemEndereco} item(ns) sem endereçamento completo.
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </article>
                      );
                    })
                  )}
                </div>
              </div>
            </div>

            {/* Painel lateral */}
            <div className="col-lg-4">
              {/* Seleção Rápida por Rua */}
              <div className="card border-0 shadow-sm mb-4">
                <div className="card-header bg-primary text-white py-3">
                  <h6 className="mb-0"><MapPin size={18} className="me-2" />Seleção Rápida por Rua</h6>
                </div>
                <div className="card-body">
                  <p className="small text-muted mb-3">Selecione todos os pedidos que possuem itens na rua:</p>
                  <div className="d-grid gap-2">
                    {todasRuas.map(rua => {
                      const cor = getRuaColor(rua);
                      const pedidosRua = pedidosFiltrados.filter(p =>
                        p.itens.some(item => normalizarRua(item.rua) === rua)
                      ).length;
                      const todosComRua = pedidosDisponiveis.filter(p =>
                        p.itens.some(item => normalizarRua(item.rua) === rua)
                      ).length;
                      return (
                        <div key={rua} className="d-flex gap-2">
                          <button
                            className={`btn btn-outline-${cor.btn} flex-grow-1 text-start d-flex justify-content-between align-items-center`}
                            onClick={() => selecionarPorRua(rua)}
                            title="Selecionar pedidos filtrados desta rua"
                          >
                            <span>{formatarRua(rua)}</span>
                            <span className="badge bg-secondary">{pedidosRua}</span>
                          </button>
                          <button
                            className={`btn btn-${cor.btn}`}
                            onClick={() => selecionarTodosItensRua(rua)}
                            title="Selecionar TODOS os pedidos com itens nesta rua"
                          >
                            Todos ({todosComRua})
                          </button>
                        </div>
                      );
                    })}
                  </div>
                  <div className="alert alert-info mt-3 mb-0 small">
                    <strong>🎨 Legendas de Cores:</strong>
                    <div className="mt-2">
                      {todasRuas.map(rua => {
                        const cor = getRuaColor(rua);
                        return (
                          <div key={rua} className="mb-1">
                            <span className={`badge ${cor.badge}`}>{formatarRua(rua)}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>

              {/* Painel de Geração */}
              <div className="card border-0 shadow-sm mb-4">
                <div className="card-header bg-success text-white py-3">
                  <h5 className="mb-0"><Plus size={20} className="me-2" />Gerar Nova Onda</h5>
                </div>
                <div className="card-body">
                  {pedidosSelecionados.length > 0 ? (
                    <>
                      <div className="mb-3">
                        <small className="text-muted d-block mb-2">Pedidos Selecionados:</small>
                        <div className="d-flex flex-wrap gap-2">
                          {pedidosSelecionados.map(p => (
                            <span key={p.id} className="badge bg-primary">{p.id}</span>
                          ))}
                        </div>
                      </div>
                      <div className="mb-3">
                        <div className="d-flex justify-content-between mb-2">
                          <span className="text-muted">Volumes:</span>
                          <strong>{totalItensSelecionados}</strong>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted">Ruas na Rota:</span>
                          <strong>{[...new Set(pedidosSelecionados.flatMap(p => p.itens.map(i => normalizarRua(i.rua))))].length}</strong>
                        </div>
                      </div>
                      <button className="btn btn-success w-100" onClick={gerarCarga}>
                        <Plus size={18} className="me-2" />Gerar Onda de Separação
                      </button>
                      <button
                        className="btn btn-outline-secondary w-100 mt-2"
                        onClick={() => setPedidosSelecionados([])}
                      >
                        <Trash2 size={18} className="me-2" />Limpar Seleção
                      </button>
                    </>
                  ) : (
                    <div className="text-center text-muted py-4">
                      <Package size={48} className="mb-3 opacity-25" />
                      <p className="mb-0">Selecione pedidos para gerar uma onda</p>
                    </div>
                  )}
                </div>
              </div>

              {/* Ondas Geradas */}
              <div className="card border-0 shadow-sm">
                <div className="card-header bg-white border-0 py-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">
                      <Truck size={20} className="me-2" />
                      Ondas Geradas
                    </h5>
                    <div className="d-flex gap-2 align-items-center">
                      <span className="badge bg-primary">
                        {(() => {
                          const todasCargas = cargas?.data || cargas || [];
                          const ativas = todasCargas.filter(c => !c.dtfim);
                          return ativas.length;
                        })()} Ativas
                      </span>
                      <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => setMostrarFinalizadas(!mostrarFinalizadas)}
                      >
                        {mostrarFinalizadas ? <EyeOff size={14} /> : <Eye size={14} />}
                        <span className="ms-1">Finalizadas</span>
                      </button>
                    </div>
                  </div>
                </div>

                <div className="card-body" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                  {(() => {
                    // Separa cargas ativas (dtfim null) e finalizadas (dtfim não null)
                    const todasCargas = cargas?.data || cargas || [];
                    const ativas = todasCargas.filter(c => !c.dtfim);
                    const finalizadas = todasCargas.filter(c => c.dtfim);

                    const cargasParaMostrar = mostrarFinalizadas ? finalizadas : ativas;

                    if (todasCargas.length === 0) {
                      return (
                        <div className="text-center text-muted py-4">
                          <Truck size={48} className="mb-3 opacity-25" />
                          <p className="mb-0">Nenhuma onda gerada ainda</p>
                        </div>
                      );
                    }

                    if (cargasParaMostrar.length === 0) {
                      return (
                        <div className="text-center text-muted py-4">
                          <Truck size={48} className="mb-3 opacity-25" />
                          <p className="mb-0">
                            {mostrarFinalizadas ? 'Nenhuma onda finalizada' : 'Nenhuma onda ativa'}
                          </p>
                        </div>
                      );
                    }

                    return (
                      <>
                        {/* ONDAS ATIVAS */}
                        {!mostrarFinalizadas && ativas.length > 0 && (
                          <div className="mb-3">
                            <h6 className="text-muted small mb-3 text-uppercase fw-bold">
                              <div className="d-flex align-items-center gap-2">
                                <div style={{ height: '2px', width: '30px', backgroundColor: '#0d6efd' }}></div>
                                ONDAS ATIVAS
                                <div style={{ height: '2px', flex: 1, backgroundColor: '#0d6efd' }}></div>
                              </div>
                            </h6>
                            {ativas.map(carga => {
                              // Determina o status baseado nas datas
                              const getStatus = () => {
                                if (carga.dtfim) return { text: 'Finalizada', class: 'bg-success' };
                                if (carga.dtinicio) return { text: 'Em Separação', class: 'bg-info' };
                                return { text: 'Aguardando Separação', class: 'bg-warning text-dark' };
                              };

                              const status = getStatus();

                              return (
                                <div key={carga.id || carga.uuid} className="card mb-3 border-primary border-2">
                                  <div className="card-body p-3">
                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                      <div>
                                        <h6 className="mb-1">
                                          <strong>Onda #{carga.id}</strong>
                                          {!carga.persisted && (
                                            <span className="badge bg-warning text-dark ms-2">
                                              <i className="bi bi-exclamation-triangle me-1"></i>
                                              Não Salva
                                            </span>
                                          )}
                                        </h6>
                                        <div className="small text-muted d-flex align-items-center gap-3">
                                          <span>
                                            <i className="bi bi-box-seam me-1"></i>
                                            {carga.totalpedidos || 0} pedidos
                                          </span>
                                          <span>
                                            <i className="bi bi-list-check me-1"></i>
                                            {carga.totalitens || 0} Volume(s):
                                          </span>
                                        </div>
                                      </div>
                                      <span className={`badge ${status.class}`}>
                                        {status.text}
                                      </span>
                                    </div>

                                    {/* Separador */}
                                    {carga.separador && (
                                      <div className="mb-2">
                                        <span className="badge bg-light text-dark border">
                                          👤 {carga.separador}
                                        </span>
                                      </div>
                                    )}

                                    {/* Rota de Separação */}
                                    {carga.rotaSeparacao && carga.rotaSeparacao.length > 0 && (
                                      <div className="mb-2">
                                        <small className="text-muted d-block mb-1">
                                          <i className="bi bi-signpost-2 me-1"></i>
                                          Rota:
                                        </small>
                                        <div>
                                          {carga.rotaSeparacao.map((rua, idx) => {
                                            const cor = getRuaColor ? getRuaColor(rua) : { badge: 'bg-secondary' };
                                            return (
                                              <span key={idx} className={`badge ${cor.badge} me-1 mb-1`}>
                                                {formatarRua ? formatarRua(rua) : rua}
                                              </span>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    )}

                                    {/* Data de Início */}
                                    {carga.dtinicio && (
                                      <div className="small text-muted mb-2">
                                        <i className="bi bi-clock-history me-1"></i>
                                        <strong>Iniciada em:</strong> {new Date(carga.dtinicio).toLocaleString('pt-BR')}
                                      </div>
                                    )}

                                    {/* Botões de Ação */}
                                    <div className="d-flex gap-1 flex-wrap mt-3 pt-2 border-top">
                                      <button
                                        className="btn btn-sm btn-primary"
                                        onClick={() => visualizarCarga(carga)}
                                        title="Visualizar detalhes"
                                      >
                                        <Eye size={14} className="me-1" />
                                        Visualizar
                                      </button>
                                      <button
                                        className="btn btn-sm btn-outline-secondary"
                                        onClick={() => imprimirQRCode(carga)}
                                        title="Imprimir Etiqueta QR Code A4"
                                        disabled={!carga.persisted}
                                      >
                                        <QrCode size={14} className="me-1" />
                                        QR Code
                                      </button>
                                      <button
                                        className="btn btn-sm btn-outline-warning"
                                        onClick={() => imprimirEtiqueta10x15(carga)}
                                        title="Imprimir Etiqueta 10x15cm"
                                        disabled={!carga.persisted}
                                      >
                                        <Barcode size={14} className="me-1" />
                                        10x15cm
                                      </button>
                                      <button
                                        className="btn btn-sm btn-outline-info"
                                        onClick={() => gerarPDFOnda(carga)}
                                        title="Imprimir Packing List Completo"
                                        disabled={!carga.persisted}
                                      >
                                        <Printer size={14} className="me-1" />
                                        Packing List
                                      </button>
                                      {status.text === 'Aguardando Separação' && (
                                        <button
                                          className="btn btn-sm btn-success"
                                          onClick={() => abrirModalAtribuir(carga)}
                                          title="Atribuir separador"
                                        >
                                          <Plus size={14} className="me-1" />
                                          Atribuir
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}

                        {/* ONDAS FINALIZADAS */}
                        {mostrarFinalizadas && finalizadas.length > 0 && (
                          <div>
                            <h6 className="text-muted small mb-3 text-uppercase fw-bold">
                              <div className="d-flex align-items-center gap-2">
                                <div style={{ height: '2px', width: '30px', backgroundColor: '#198754' }}></div>
                                ONDAS FINALIZADAS
                                <div style={{ height: '2px', flex: 1, backgroundColor: '#198754' }}></div>
                              </div>
                            </h6>
                            {finalizadas.map(carga => (
                              <div key={carga.id || carga.uuid} className="card mb-3 border-success">
                                <div className="card-body p-3 bg-light bg-opacity-25">
                                  <div className="d-flex justify-content-between align-items-start mb-2">
                                    <div>
                                      <h6 className="mb-1">
                                        <strong>Onda #{carga.id}</strong>
                                        <span className="badge bg-success ms-2">
                                          <i className="bi bi-check-circle me-1"></i>
                                          Finalizada
                                        </span>
                                      </h6>
                                      <div className="small text-muted d-flex align-items-center gap-3">
                                        <span>
                                          <i className="bi bi-box-seam me-1"></i>
                                          {carga.totalpedidos || 0} pedidos
                                        </span>
                                        <span>
                                          <i className="bi bi-list-check me-1"></i>
                                          {carga.totalitens || 0} itens
                                        </span>
                                      </div>
                                    </div>
                                    <button
                                      className="btn btn-sm btn-outline-secondary"
                                      onClick={() => visualizarCarga(carga)}
                                      title="Visualizar detalhes"
                                    >
                                      <Eye size={14} />
                                    </button>
                                  </div>

                                  {/* Separador */}
                                  {carga.separador && (
                                    <div className="mb-2">
                                      <span className="badge bg-light text-dark border">
                                        👤 {carga.separador}
                                      </span>
                                    </div>
                                  )}

                                  {/* Data de Finalização */}
                                  {carga.dtfim && (
                                    <div className="alert alert-success mb-0 py-2 px-3 small">
                                      <i className="bi bi-calendar-check me-1"></i>
                                      <strong>Finalizada em:</strong> {new Date(carga.dtfim).toLocaleString('pt-BR', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit'
                                      })}
                                    </div>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </>
                    );
                  })()}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Modal de Atribuir Separador */}
        {mostrarModalAtribuir && ondaParaAtribuir && (
          <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={() => setMostrarModalAtribuir(false)}>
            <div className="modal-dialog" onClick={e => e.stopPropagation()}>
              <div className="modal-content">
                <div className="modal-header bg-success text-white">
                  <h5 className="modal-title">Atribuir Separador - {ondaParaAtribuir.id}</h5>
                  <button className="btn-close btn-close-white" onClick={() => setMostrarModalAtribuir(false)}></button>
                </div>
                <div className="modal-body">
                  <div className="alert alert-info">
                    <strong>Onda:</strong> {ondaParaAtribuir.id}<br />
                    <strong>Pedidos:</strong> {ondaParaAtribuir.pedidos.length}<br />
                    <strong>Volume(s):</strong> {ondaParaAtribuir.totalItens}<br />
                    <strong>Rota:</strong> {ondaParaAtribuir.rotaSeparacao.map((rua, idx) => {
                      const cor = getRuaColor(rua);
                      return (
                        <span key={idx} className={`badge ${cor.badge} me-1`}>{formatarRua(rua)}</span>
                      );
                    })}
                  </div>

                  <label className="form-label"><strong>Selecione o Separador:</strong></label>
                  <select
                    className="form-select form-select-lg mb-3"
                    value={separadorSelecionado}
                    onChange={(e) => setSeparadorSelecionado(e.target.value)}
                  >
                    <option value="">-- Selecione um separador --</option>
                    {separadores.map(sep => (
                      <option
                        key={sep.id}
                        value={sep.id}
                        disabled={sep.status !== 'Disponivel'}
                      >
                        {sep.nome} - {sep.id} ({sep.status})
                      </option>
                    ))}
                  </select>

                  <div className="card">
                    <div className="card-header bg-light">
                      <h6 className="mb-0">Separadores Disponíveis</h6>
                    </div>
                    <div className="list-group list-group-flush">
                      {separadores.filter(s => s.status === 'Disponivel').map(sep => (
                        <div
                          key={sep.id}
                          className={`list-group-item d-flex justify-content-between align-items-center ${String(separadorSelecionado) === String(sep.id) ? 'active' : ''}`}
                          style={{ cursor: 'pointer' }}
                          onClick={() => setSeparadorSelecionado(sep.id)}
                        >
                          <div>
                            <strong>{sep.nome}</strong>
                            <br />
                            <small className={String(separadorSelecionado) === String(sep.id) ? 'text-white-50' : 'text-muted'}>{sep.id}</small>
                          </div>
                          <span className={`badge ${String(separadorSelecionado) === String(sep.id) ? 'bg-light text-dark' : 'bg-success'}`}>
                            {sep.status}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={() => setMostrarModalAtribuir(false)}>
                    Cancelar
                  </button>
                  <button className="btn btn-success" onClick={atribuirSeparador}>
                    <CheckCircle size={18} className="me-2" />
                    Atribuir Onda
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal de Visualização / Iniciar Separação */}
        {mostrarModal && cargaSelecionada && (
          <div
            className="modal show d-block"
            style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
            onClick={() => setMostrarModal(false)}
          >
            <div className="modal-dialog modal-xl" onClick={e => e.stopPropagation()}>
              <div className="modal-content">
                <div className="modal-header bg-primary text-white">
                  <h5 className="modal-title">
                    Detalhes da Onda {cargaSelecionada.id}
                  </h5>
                  <button
                    className="btn-close btn-close-white"
                    onClick={() => setMostrarModal(false)}
                  ></button>
                </div>

                <div className="modal-body">
                  {modalLoadingDetalhe ? (
                    <div className="text-center py-5">
                      <Loader size={48} className="text-primary mb-3" style={{ animation: 'spin 1s linear infinite' }} />
                      <p className="text-muted">Carregando detalhes...</p>
                    </div>
                  ) : (
                    <>
                      <div className="row mb-4">
                        <div className="col-md-4">
                          <div className="text-center p-3 bg-light rounded">
                            <h4>{(cargaSelecionada.pedidos && cargaSelecionada.pedidos.length) || 0}</h4>
                            <small className="text-muted">Pedidos</small>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="text-center p-3 bg-light rounded">
                            <h4>{cargaSelecionada.totalItens || 0}</h4>
                            <small className="text-muted">Volume(s)</small>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="text-center p-3 bg-light rounded">
                            <h4>{(cargaSelecionada.rotaSeparacao && cargaSelecionada.rotaSeparacao.length) || 0}</h4>
                            <small className="text-muted">Ruas na Rota</small>
                          </div>
                        </div>
                      </div>

                      <div className="alert alert-info">
                        <strong>Rota de Separação:</strong>{' '}
                        {(cargaSelecionada.rotaSeparacao || []).map((rua, idx) => {
                          const cor = getRuaColor(rua);
                          return (
                            <span
                              key={idx}
                              className={`badge ${cor.badge} me-1`}
                            >
                              {formatarRua(rua)}
                            </span>
                          );
                        })}
                      </div>

                      <h6 className="mb-3">Itens por Rua (Ordem de Separação):</h6>
                      {(cargaSelecionada.rotaSeparacao || []).map(rua => {
                        const cor = getRuaColor(rua);
                        const itens = (cargaSelecionada.itensPorRua && cargaSelecionada.itensPorRua[rua]) || [];
                        return (
                          <div key={rua} className="mb-4">
                            <h6 className={`${cor.bg} ${cor.text} p-2 rounded`}>
                              <MapPin size={16} className="me-2" />
                              {formatarRua(rua)}
                            </h6>
                            <div className="table-responsive">
                              <table className="table table-sm table-hover">
                                <thead className="table-light">
                                  <tr>
                                    <th>Pedido</th>
                                    <th>Cliente</th>
                                    <th>SKU</th>
                                    <th>Descrição</th>
                                    <th>Qtd</th>
                                    <th>Endereço</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {itens.map((item, idx) => (
                                    <tr key={idx}>
                                      <td>
                                        <span className="badge bg-secondary">
                                          {item.pedidoId}
                                        </span>
                                      </td>
                                      <td>{item.cliente}</td>
                                      <td>
                                        <span className="badge bg-dark">{item.sku}</span>
                                      </td>
                                      <td>{item.descricao}</td>
                                      <td>
                                        <strong>{item.qtd}</strong>
                                      </td>
                                      <td>
                                        <code>{item.endereco}</code>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        );
                      })}
                    </>
                  )}
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setMostrarModal(false)}
                  >
                    Fechar
                  </button>

                  <button
                    className="btn btn-success"
                    disabled={gerandoOnda || modalLoadingDetalhe}
                    onClick={async () => {
                      if (cargaSelecionada.persisted) {
                        alert('Onda já está salva no banco.');
                        return;
                      }
                      await iniciarSeparacaoSalvar(cargaSelecionada);
                    }}
                  >
                    {gerandoOnda ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></span>
                        Gerando...
                      </>
                    ) : (
                      <>
                        <CheckCircle size={18} className="me-2" />
                        Iniciar Separação
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default WavePickingSystem;
